module.exports = __webpack_public_path__ + "img/full4-min.3a8e9c6f.png";